import {
    KindLogo,
    PerrigoLogo,
    ConstellationLogo,
    ConstellationSecondaryLogo,
    TruFruLogo,
    CooperLogo,
    DemoLogo,
    GPLogo,
    NaturesBakeryLogo,
    NomadFoodLogo,
    perrigoSpainLogo,
    perrigoPolandLogo,
    perrigoBelgiumLogo,
    perrigoRomaniaLogo,
    perrigoItalyLogo,
    sauerBrandsLogo,
    HormelFoodsLogo,
    HormelFoodsSecondaryLogo,
    PPALogo,
    DanoneLogo,
    JDELogo,
    CotyLogo,
} from 'assets/images';

const tenantLogoMapping: Record<string, string> = {
    kind: KindLogo,
    perrigo: PerrigoLogo,
    constellation: ConstellationLogo,
    truFru: TruFruLogo,
    cooper: CooperLogo,
    demo: DemoLogo,
    gp: GPLogo,
    naturesBakery: NaturesBakeryLogo,
    nomadFoods: NomadFoodLogo,
    perrigoSpain: perrigoSpainLogo,
    perrigoPoland: perrigoPolandLogo,
    perrigoBelgium: perrigoBelgiumLogo,
    sauerBrands: sauerBrandsLogo,
    hormelFoods: HormelFoodsLogo,
    ppa: PPALogo,
    danone: DanoneLogo,
    jde: JDELogo,
    coty: CotyLogo,
    perrigoRomania: perrigoRomaniaLogo,
    perrigoItaly: perrigoItalyLogo,
};

const secondaryTenantLogoMapping: Record<string, string> = {
    constellation: ConstellationSecondaryLogo,
    hormelFoods: HormelFoodsSecondaryLogo,
};

export const DEFAULT_TENANT_LOGO = DemoLogo;

export const getTenantLogo = (tenantId: string = ''): string => {
    return tenantLogoMapping[tenantId] || DEFAULT_TENANT_LOGO;
};

export const getSecondaryTenantLogo = (tenantId: string = ''): string | undefined => {
    return secondaryTenantLogoMapping[tenantId];
};
